// src/services/printer.js
class PrinterService {
  constructor(socket) {
    this.socket = socket;
    this.printQueue = [];
    this.isPrinting = false;
  }

  // Print KOT silently with proper error handling
  async printKOT(kotData) {
    if (!this.socket || !this.socket.connected) {
      console.error('Socket not connected');
      return false;
    }

    if (!kotData || !kotData.kot_items || !Array.isArray(kotData.kot_items)) {
      console.error('Invalid KOT data');
      return false;
    }

    return new Promise((resolve) => {
      this.socket.emit("print_kot", kotData, (response) => {
        if (response?.status === 'success') {
          resolve(true);
        } else {
          console.error('Print failed:', response?.message || 'Unknown error');
          this.addToPrintQueue(kotData);
          resolve(false);
        }
      });
    });
  }

  // Properly implemented queue system
  addToPrintQueue(kotData) {
    if (!kotData) return;
    
    this.printQueue.push({
      kotData,
      timestamp: new Date(),
      attempts: 0
    });
    
    console.log(`Added KOT #${kotData.id} to print queue`);
    this.processPrintQueue();
  }

  async processPrintQueue() {
    if (this.isPrinting || this.printQueue.length === 0) return;
    
    this.isPrinting = true;
    const queueItem = this.printQueue[0];
    
    try {
      queueItem.attempts++;
      const success = await this.printKOT(queueItem.kotData);
      
      if (success) {
        this.printQueue.shift();
        console.log(`Successfully printed queued KOT #${queueItem.kotData.id}`);
      } else if (queueItem.attempts >= 3) {
        console.error(`Max attempts reached for KOT #${queueItem.kotData.id}`);
        this.printQueue.shift();
      }
    } catch (error) {
      console.error('Queue processing error:', error);
    } finally {
      this.isPrinting = false;
      if (this.printQueue.length > 0) {
        setTimeout(() => this.processPrintQueue(), 5000);
      }
    }
  }
}

export default PrinterService;